import { render, staticRenderFns } from "./lot.vue?vue&type=template&id=deae4d0e&scoped=true"
import script from "./lot.vue?vue&type=script&lang=js"
export * from "./lot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deae4d0e",
  null
  
)

export default component.exports